/*
 * @file: index.js
 * @description: It Contain rest functions for api call .
 * @author: Anil
 */

import axios from "axios";
import querystring from "querystring";
import { setAuthorizationToken } from "../auth";
import { toast } from "react-toastify";
import loader from "../loader";
import environment from "../../environment";
import methodModel from "../methods";
import swal from "sweetalert";

let config = {
  headers: { "Content-Type": "application/json" },
};

const FileConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};
let baseUrl = environment.api;

const NotAllowedKeys = [
  "isDeleted",
  "updatedBy",
  "createdAt",
  "updatedAt",
  "_id",
  "_v",
  "__v",
];
const handleError = (err, hideError) => {
  let message = "";
  if (err) {
    message = err?.error?.message || err?.message || "Server Error";
    if (message?.toLowerCase() == "user not found") {
      hideError = true;

      swal({
        text: message,
        icon: "error",
        className: "smallmodal",
      }).then(() => {
        localStorage.removeItem("persist:admin-app");
        localStorage.removeItem("token");

        window.location.href = "/login";
      });

      return;
    }
  }

  if (!hideError) {
    swal({
      text: message,
      icon: "error",
      className: "smallmodal",
    });
  }
};

class ApiClient {
  static post(
    url1,
    params,
    base = "",
    hidError = "",
    errorstate = null,
    stringify = true,
  ) {
    let url = baseUrl + url1;
    if (base) url = base + url1;
    NotAllowedKeys?.map((_key) => {
      try {
        delete params[_key];
      } catch {}
    });
    setAuthorizationToken(axios);
    return new Promise(function (fulfill, reject) {
      let paramsNew = stringify ? JSON.stringify(params) : params;
      axios
        .post(url, paramsNew, config)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;

            if (errorstate) {
              errorstate(error?.response?.data?.error?.message);
            }
            if (
              error?.response?.data?.error?.message ==
              "Please verify your email first."
            ) {
              localStorage.setItem("SignUpId", error?.response?.data?.id);

              try {
                document.getElementById("routerDivlogin").click();
              } catch {}
              // window.location.assign("/otppage")
            }

            handleError(eres.data, hidError);
            fulfill({ ...eres.data, success: false });
          } else {
            reject(error);
          }
        });
    });
  }

  static put(url1, params, base = "") {
    let url = baseUrl + url1;
    NotAllowedKeys?.map((_key) => {
      try {
        delete params[_key];
      } catch {}
    });
    if (base) url = base + url1;
    setAuthorizationToken(axios);
    return new Promise(function (fulfill, reject) {
      axios
        .put(url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            reject(error);
          }
        });
    });
  }
  static patch(url1, params, base = "") {
    let url = baseUrl + url1;
    if (base) url = base + url1;
    setAuthorizationToken(axios);
    return new Promise(function (fulfill, reject) {
      axios
        .patch(url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            reject(error);
          }
        });
    });
  }
  static get(
    url1,
    params = {},
    base = "",
    hidError = "",
    obj = { apiCall: false, cancelTokenSource: null, Callfunction: null },
  ) {
    let url = baseUrl + url1;
    if (base) url = base + url1;

    let query = querystring.stringify(params);
    url = query ? `${url}?${query}` : url;
    if (obj.apiCall) {
      localStorage.removeItem(url);
    }
    setAuthorizationToken(axios);
    return new Promise(function (fulfill, reject) {
      // if (!obj?.apiCall) {
      //     let sdata =localStorage.getItem(String(url))
      //     if (sdata) {
      //         if (obj?.response) obj.response(JSON.parse(sdata))
      //         fulfill(JSON.parse(sdata));
      //     }
      // }

      let newconfig = config;
      if (obj.cancelTokenSource?.token) {
        newconfig["cancelToken"] = obj.cancelTokenSource?.token;
      } else {
        newconfig["cancelToken"] = null;
      }
      axios
        .get(url, newconfig)
        .then(function (response) {
          let data = response && response.data;
          if (obj?.response) obj.response(data);
          fulfill(data);
        })
        .catch(function (error) {
          loader(false);
          if (obj?.Callfunction) {
            obj?.Callfunction();
          }
          if (error && error.response) {
            let eres = error.response;
            if (!hidError) {
              handleError(eres.data, hidError);
            }
            let err = { ...eres.data, success: false };
            if (obj?.response) obj.response(err);
            fulfill(err);
          } else {
            if (obj?.response) obj.response(error);
            reject(error);
          }
        });
    });
  }

  static getAll({
    url,
    params = {},
    base = "",
    hidError = "",
    apiCall = false,
    cancelTokenSource = "",
    response = () => {},
  }) {
    return this.get(url, params, base, hidError, {
      apiCall: apiCall,
      response: response,
      cancelTokenSource: cancelTokenSource,
    });
  }

  static delete(url1, params = {}, base = "") {
    let url = baseUrl + url1;
    if (base) url = base + url1;

    let query = querystring.stringify(params);
    url = query ? `${url}?${query}` : url;
    setAuthorizationToken(axios);
    return new Promise(function (fulfill, reject) {
      axios
        .delete(url, config)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static allApi(
    url,
    params,
    method = "get",
    hidError = "",
    setError = null,
    apiUrl = "",
  ) {
    if (method == "get") {
      return this.get(url, params, apiUrl);
    } else if (method == "put") {
      return this.put(url, params, apiUrl);
    } else if (method == "patch") {
      return this.patch(url, params, apiUrl);
    }
    if (method == "post") {
      return this.post(url, params, apiUrl, hidError, setError);
    }
  }

  static postFormData(url, params) {
    url = baseUrl + url;
    setAuthorizationToken(axios);

    return new Promise((fulfill, reject) => {
      const body = new FormData();

      Object.keys(params).forEach((key) => {
        const value = params[key];

        if (Array.isArray(value)) {
          value.forEach((file) => body.append(key, file, file.name));
        } else if (value instanceof File) {
          body.append(key, value, value.name);
        } else {
          body.append(key, value);
        }
      });

      axios
        .post(url, body, FileConfig)
        .then((response) => {
          const res = response?.data || {};
          fulfill({
            ...res,
            fileName: res?.location || res?.fileName,
            filePath: res?.location || res?.filePath,
          });
        })
        .catch((error) => {
          loader(false);
          if (error?.response) {
            handleError(error.response.data);
            fulfill(error.response.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static async multiImageUpload(url, params) {
    url = baseUrl + url;
    setAuthorizationToken(axios);
    let body = new FormData();
    let oArr = Object.keys(params);
    oArr.map((itm) => {
      body.append(itm, params[itm]);
    });

    return await axios
      .post(url, body, FileConfig)

      .then(function (response) {
        return response && response.data;
      })
      .catch(function (error) {
        return error && error.response;
      });
  }
}

export default ApiClient;
